export default __webpack_public_path__ + "static/media/Modal_EMOJI.a2c98649.jpg";